import React, { useState, useEffect } from 'react';
import { Box, List, ListItem, ListItemAvatar, ListItemText, Popover, Skeleton, Typography } from '@mui/material';
import styles from '../../../../custom/style.module.css';
import flightStyles from '../../flights/tabs/flightreport/reports.module.css';
import { dateTolocale } from '../../../../utils/converter';
import http from '../../../../utils/http';

const getBadgeColor = (type, op) => {
  if (type?.includes('AI') || op === 'ai_refine') return '#0284c7';
  if (op === 'generate') return '#16a34a';
  if (op === 'select_main') return '#9333ea';
  if (op === 'create_version') return '#092b4a';
  return '#eab308';
};

const getBadgeLabel = (type, op) => {
  if (type?.includes('AI')) return 'AI Refined';
  if (op === 'generate') return 'Generated';
  if (op === 'select_main') return 'Main Selected';
  if (op === 'create_version') return 'New Version';
  return 'Manual Edit';
};

const FwbHistoryPopover = ({ open = false, anchorEl = null, onClose, docId = null }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && docId) {
      setLoading(true);
      http
        .get(`/doc_fwb/history/${docId}`)
        .then((res) => {
          if (res?.data?.data) {
            setLogs(res.data.data);
          }
          setLoading(false);
        })
        .catch((err) => {
          console.error('Error fetching FWB history:', err);
          setLoading(false);
        });
    }
  }, [open, docId]);

  return (
    <Popover
      open={Boolean(open && anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <List
        sx={{
          width: '100%',
          maxWidth: 380,
          minWidth: 320,
          bgcolor: 'background.paper',
          p: 2,
          maxHeight: 400,
          minHeight: 160,
          overflowY: 'auto',
        }}
      >
        {!loading ? (
          logs.length > 0 ? (
            logs.map((row, index) => {
              const badgeBg = getBadgeColor(row.type, row.operation);
              const badgeText = getBadgeLabel(row.type, row.operation);
              const userName = row.user?.name || 'System';
              const userRole = row.user?.role ? ` (${row.user.role})` : '';
              const createdDate = dateTolocale(row.created_at, 'DD MMM YYYY HH:mm');

              return (
                <ListItem key={row.id || index} className={flightStyles.historyListItem}>
                  <ListItemAvatar className={styles.mr2}>
                    <Typography
                      variant='span'
                      color='white'
                      bgcolor={badgeBg}
                      textTransform='uppercase'
                      fontSize='10px'
                      fontWeight={800}
                      px={0.5}
                      py={0.25}
                      borderRadius='4px'
                      lineHeight='normal'
                      minWidth='75px'
                      display='block'
                      textAlign='center'
                    >
                      {badgeText}
                    </Typography>
                  </ListItemAvatar>
                  <ListItemText
                    className={flightStyles.historyListText}
                    primaryTypographyProps={{
                      fontSize: 12,
                      color: 'primary.main',
                      fontWeight: 500,
                    }}
                    secondaryTypographyProps={{ fontSize: 11.5 }}
                    primary={row.msg || `${badgeText} applied`}
                    secondary={`${createdDate} | ${userName}${userRole}`}
                  />
                </ListItem>
              );
            })
          ) : (
            <Box
              sx={{
                textAlign: 'center',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                py: 4,
              }}
            >
              <Typography variant='span' color='textSecondary' fontSize='0.8rem'>
                No History Found
              </Typography>
            </Box>
          )
        ) : (
          Array.from({ length: 3 }).map((_, index) => (
            <ListItem key={index}>
              <Skeleton variant='rectangular' width={320} height={50} sx={{ borderRadius: '6px' }} />
            </ListItem>
          ))
        )}
      </List>
    </Popover>
  );
};

export default FwbHistoryPopover;

